/* eslint-disable react/prop-types */
import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';

const PublicRoute = ({ isLogin, isWebAcess, component: Component, path, exact, userAccess }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const hasInviteToken = path === '/reset-password' && params.get('invite');

  // Check if we're in OTP validation flow - don't redirect if so
  const isOtpFlow = sessionStorage.getItem('otp_validation_in_progress') === 'true';
  const isOnLoginPage = path === '/login' || location.pathname === '/login';

  // Allow access to reset-password page with invite token even if logged in
  if (hasInviteToken) {
    return <Route exact={exact} path={path} component={Component} />;
  }

  // Don't redirect if we're on login page and in OTP flow
  if (isOnLoginPage && isOtpFlow) {
    return <Route exact={exact} path={path} component={Component} />;
  }

  const noAccessOnly =
    Array.isArray(userAccess) &&
    userAccess.length === 1 &&
    userAccess.includes('no-access');

  return (
    <Route
      exact={exact}
      path={path}
      render={() =>
        isLogin ? (
          <Redirect
            to={
              noAccessOnly
                ? '/no-access'
                : userAccess?.includes('web-page' || 'web-page-without-create-project' || 'super-admin')
                ? '/dashboard'
                : userAccess?.includes('admin')
                ? '/admin'
                : userAccess?.some((group) =>
                    ['heat-profile', 'coating-record-db', 'dcal-generator'].includes(group)
                  )
                ? '/technical'
                : userAccess?.includes('analysis')
                ? '/log-report'
                : userAccess?.includes('super-admin')
                ? '/dashboard'
                : '/web-page'
            }
          />
        ) : (
          <Component />
        )
      }
    />
  );
};

export default PublicRoute;
